<template>
  <div v-if="isMobile" class="mobile-overlay flex-center h-100">
    <div class="text-align-center" aria-labelledby="notification-title">
      <h1 id="notification-title">
        Mobile view is not supported.
        <br />
        Use a desktop browser (min width 1024px).
        <br />
        Some features may be unavailable on smaller screens.
        <span class="sr-only"
          >Mobile view is not supported. Use a desktop browser (min width 1024px). Some features may be unavailable on
          smaller screens.</span
        >
      </h1>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useMediaQuery } from '@/composable/useMediaQuery'

  const isMobile = useMediaQuery('(max-width: 1023px)')
</script>

<style scoped>
  .mobile-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background-color: #fff;
  }
</style>
